export class ProductAttributeDto {
  value: string;
  type: string;
  name: string;
  reference?: string;
  id?: string;

  constructor(d?: ProductAttributeDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
